import { Grid, Link } from '@material-ui/core';
import React, { FC, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import SearchService from '../../services/search.service';
import { IReportsComponent } from '../../store/models';
import { FormValues } from '../../store/models/employeeData.model';
import EmployeeDataComponent from './employeData.component';
import LogoComponent from './logo.component';
import ReportsComponent from './reports.component';
import FileSaver from 'file-saver';
import imgAdobe from '../../assets/imgAdobe.png'

const ResultComponent: FC = () => {
    const user: FormValues = useSelector((user: IReportsComponent) => user.report.user)
    const history = useHistory()
    const report = useReportData()

    useEffect(() => {
        !report && history.push('/')
    }, [report, history]);


    const onClickHandler = () => {
        SearchService.getDownloadPdf(user).then(result => {
            FileSaver.saveAs(result, `ScreenerTestDetails_${user.firstName}_${user.lastName}.pdf`);
        }).catch((ex: any) => { console.log(ex.message) })
    }

    return (
        <div>
            <LogoComponent />
            <Grid container direction="row" justify="center">
                <Grid item>
                    <Link style={{ paddingRight: 30 }} component='button' onClick={onClickHandler}>Save result to PDF<img alt='adobe-logo' src={imgAdobe} style={{ width: 20, marginLeft: 5 }} /></Link>
                </Grid>
            </Grid>

            <EmployeeDataComponent />
            <ReportsComponent />
        </div >
    )

}



export default ResultComponent

const useReportData = () => {
    return useSelector((state: IReportsComponent) => state.report.tasks)
}
